import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const PaymentHeader = styled.div<{ backgroundColor?: string }>`
  padding: 20px;
  background-color: ${(p) => p.backgroundColor || theme.lightBlueBg};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 15px 15px 0px 0px;
  gap: 10px;
`;

export const PaymentBreakupTitle = styled.div`
  margin-bottom: 8px;
`;

export const OutlineButton = styled.button<{ disabled?: boolean }>`
  width: 100%;
  padding: 12px 20px;
  margin-top: 16px;
  background: transparent;
  border: 2px solid ${theme.blueText};
  border-radius: 8px;
  color: ${theme.blueText};
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  opacity: ${(p) => (p.disabled ? 0.45 : 1)};
  pointer-events: ${(p) => (p.disabled ? "none" : "auto")};
  transition: all 0.2s ease-in-out;

  &:hover:not(:disabled) {
    background-color: ${theme.blueText};
    color: ${theme.whiteText};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 140, 255, 0.3);
  }
`;
